import { Column, Row } from '~components/table-view-v3';
import { ReferenceTooltips } from '~support-at-home/components/common';

const columns: Column[] = [
  {
    id: 'reconciliations',
    header: 'Reconciliations',
    type: 'custom',
    component: ReferenceTooltips,
    componentProps: (row: Row) => ({
      id: row?.id,
      references: row?.reconciliations || [],
    }),
  },
  {
    id: 'client_name',
    header: 'Client Name',
    type: 'text',
  },
  {
    id: 'total_contribution_amount',
    header: 'Co-Contribution',
    type: 'currency',
    classNames: {
      header: 'cell-align-right',
      column: 'cell-align-right',
    },
  },
];

export default columns;
